/**
 * @param {*} value
 * @returns {string|undefined}
 */
function ssn (value) {
  if (!value) return

  const val = value
    .toString()
    .trim()
    .replace(/[^0-9]/g, '')

  if (val.length > 11) {
    return val.substring(0, 11)
  }

  return val
}

module.exports = { ssn }
